import { useEffect, useState } from "react";
import { Gift, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function GiftPriceAdmin() {
  const [cfg, setCfg] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/allin/config").then(({ data }) => setCfg(data)); }, []);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/allin/admin/config", { cost: Number(cfg.cost), reward: Number(cfg.reward) }); setCfg(data); toast.success("Gespeichert – gilt ab sofort für alle"); }
    catch (e) { toast.error(formatErr(e)); } finally { setBusy(false); }
  };
  if (!cfg) return <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 animate-spin text-rose-500" /></div>;
  const field = (k, label, hint) => (
    <label className="block space-y-1.5">
      <span className="text-sm font-bold">{label}</span>
      <Input type="number" min={1} value={cfg[k]} onChange={(e) => setCfg({ ...cfg, [k]: e.target.value })} data-testid={`gift-price-${k}`} className="rounded-xl" />
      <span className="block text-xs text-slate-500">{hint}</span>
    </label>
  );
  return (
    <div className="bg-white rounded-3xl p-6 border border-pink-100 space-y-5 max-w-lg" data-testid="gift-price-admin">
      <h2 className="font-bold text-lg flex items-center gap-2"><Gift className="w-5 h-5 text-rose-500" /> Mitglieder-Geschenke</h2>
      {field("cost", "Preis für den Schenker (Punkte)", "So viele Punkte werden dem Schenker pro Geschenk abgezogen.")}
      {field("reward", "Punkte für den Beschenkten", "So viele Punkte bekommt der Beschenkte gutgeschrieben.")}
      <div className="rounded-2xl bg-red-50 border border-red-200 p-3 text-sm text-red-800" data-testid="gift-price-preview">
        <b>Vorschau für Mitglieder:</b> „Achtung: Jedes Geschenk kostet dich {cfg.cost || "?"} Punkte! … Der Beschenkte bekommt {cfg.reward || "?"} Punkte.“
      </div>
      <button onClick={save} disabled={busy || !cfg.cost || !cfg.reward} data-testid="gift-price-save" className="w-full h-11 rounded-full pink-gradient text-white font-bold disabled:opacity-50">{busy ? "Speichert …" : "Speichern"}</button>
    </div>
  );
}
